export default __webpack_public_path__ + "static/businessmanFriendship-3de75bf7dbf79ce3ba352b5dceb2b247.png";